<div class="modal fade" id="modalSubscription" tabindex="-1" aria-labelledby="modalSubscriptionLabel"
    aria-hidden="true">
    <div class="modal-dialog modal-lg modal-dialog-centered">
        <div class="modal-content">
            <div class="modal-header">
                <button type="btn btn-secondary" class="btn-close" data-bs-dismiss="modal" aria-label="Close"></button>
            </div>
            <div class="modal-body">
                <p class="{{messageType}}">{{message}}</p>
            </div>
            <div class="modal-footer">
                <button type="button" class="btn btn-secondary" data-bs-dismiss="modal">Fermer</button>
            </div>
        </div>
    </div>
</div>

<div class="housing-page">
    <div class="housing-header">
        <div>
            <span class="tag">Souscription </span>
            <h1>Souscrire à un produit</h1>

        </div>
    </div>

  
    <div class="housing-card">
        <div class="view-switch">
            <button class="btn btn-primary" type="button" (click)="goToViewSubscriptions()">Lister les
                souscriptions</button>
        </div>

        <form [formGroup]="subscriptionForm" (ngSubmit)="submitSubscription()" class="housing-form">

            <div class="form-section">
                <h3>Vérification du numéro de téléphone</h3>
                <div class="phone-check-section">
                    <div class="field-group">
                        <label for="phone">Numéro de téléphone</label>
                        <div class="input-button-row">
                            <input id="phone" type="text" formControlName="phone" placeholder="Ex: 22177007980" />
                            <button type="button" class="btn btn-secondary" (click)="subscriptionByPhone()"
                                [disabled]="!subscriptionForm.value.phone">Vérifier le numéro</button>
                        </div>
                        <div class="error">
                            @if (submitted && f['phone'].invalid) {
                            <span>Le numéro de téléphone est requis et doit contenir au moins 9 chiffres.</span>
                            }
                        </div>
                    </div>
                </div>
            </div>

            <!-- Customer Summary Section - Show when customer is found -->
            @if (customerFound && existingCustomer) {
            <div class="form-section">
                <h3>Client trouvé</h3>
                <div class="customer-summary">
                    <div class="customer-info-card">
                        <h4>{{ existingCustomer.firstName }} {{ existingCustomer.lastName }}</h4>
                        <div class="info-grid">
                            <div class="info-item">
                                <span class="label">Téléphone:</span>
                                <span class="value">{{ existingCustomer.phone }}</span>
                            </div>
                            <div class="info-item">
                                <span class="label">Email:</span>
                                <span class="value">{{ existingCustomer.email }}</span>
                            </div>
                            <div class="info-item">
                                <span class="label">Document:</span>
                                <span class="value">{{ existingCustomer.documentType?.libelle }} - {{
                                    existingCustomer.documentId }}</span>
                            </div>
                            @if (existingCustomer.address) {
                            <div class="info-item">
                                <span class="label">Adresse:</span>
                                <span class="value">{{ existingCustomer.address }}</span>
                            </div>
                            }
                        </div>
                    </div>

                </div>
            </div>
            <div class="form-section">
                @if (alreadySubscriptions.length === 0) {
                <p>Aucun produit souscrit pour ce client.</p>
                } @else {
                <h3>Produits déjà souscrits</h3>
                <div class="products-grid">
                    @for (subscription of alreadySubscriptions; track subscription.id) {
                    <div class="product-card subscribed">
                        <div class="product-header">
                            <h4>{{ subscription.product?.name }}</h4>
                        </div>
                        <div class="product-details">
                            <p><strong>Type:</strong> {{ subscription.product?.type }}</p>
                            <p><strong>Zone:</strong> {{ subscription.product?.zone }}</p>
                            <p><strong>Prix:</strong> {{ subscription.product?.price }} CFA</p>
                            <p><strong>Durée:</strong> {{ subscription.product?.durationYears }} ans</p>
                            <p><strong>Date de début:</strong> {{ subscription.startDate | date }}</p>
                            <p><strong>Superficie:</strong> {{ subscription.product?.superficie }} m²</p>
                        </div>
                    </div>
                    }
                </div>
                }
            </div>
            }

            <!-- Customer Information Section - Show after phone check if no customer found -->
            @if (phoneChecked && !customerFound) {
            <div class="form-section">
                <h3>Informations du client</h3>

                <div class="grid-row">
                    <div class="field-group">
                        <label for="firstName">Prénom</label>
                        <input id="firstName" type="text" formControlName="firstName" placeholder="Ex: Demba" />
                        <div class="error">
                            @if (submitted && f['firstName'].invalid) {
                            <span>Le prénom est requis.</span>
                            }
                        </div>
                    </div>

                    <div class="field-group">
                        <label for="lastName">Nom</label>
                        <input id="lastName" type="text" formControlName="lastName" placeholder="Ex: Fall" />
                        <div class="error">
                            @if (submitted && f['lastName'].invalid) {
                            <span>Le nom est requis.</span>
                            }
                        </div>
                    </div>
                </div>

                <div class="grid-row">
                    <div class="field-group">
                        <label for="email">Email</label>
                        <input id="email" type="email" formControlName="email"
                            placeholder="Ex: namet@email.com" />
                        <div class="error">
                            @if (submitted && f['email'].invalid) {
                            <span>L'adresse email doit être valide.</span>
                            }
                        </div>
                    </div>

                    <div class="field-group">
                        <label for="documentType">Type de document</label>
                        <select id="documentType" formControlName="documentType">
                            <option value="">Sélectionnez</option>
                            @for (docType of documentTypes; track docType.code) {
                            <option [value]="docType.code">{{ docType.libelle }}</option>
                            }
                        </select>
                        <div class="error">
                            @if (submitted && f['documentType'].invalid) {
                            <span>Le type de document est requis.</span>
                            }
                        </div>
                    </div>
                </div>

                <div class="field-group full-width">
                    <label for="documentId">Numéro de document</label>
                    <input id="documentId" type="text" formControlName="documentId" placeholder="Ex: 127699" />
                    <div class="error">
                        @if (submitted && f['documentId'].invalid) {
                        <span>Le numéro de document est requis.</span>
                        }
                    </div>
                </div>

                <div class="grid-row">
                    <div class="field-group">
                        <label for="address">Adresse</label>
                        <input id="address" type="text" formControlName="address" placeholder="Ex: Dakar, yoff" />
                    </div>

                    <div class="field-group">
                        <label for="cityResidence">Ville de résidence</label>
                        <input id="cityResidence" type="text" formControlName="cityResidence" placeholder="Ex: Dakar" />
                    </div>
                </div>

                <div class="field-group full-width">
                    <label for="countryResidence">Pays de résidance</label>
                    <select id="countryResidence" type="text" formControlName="countryResidence"
                        placeholder="Ex: Senegal" >
                        <option value=""> Selectionner le pays de résidance</option>
                        @for(country of countries;track $index){
                            <option value="{{country.isoCode2}}">{{country.name}}</option>

                        }
                        <
                        </select>
                </div>
            </div>
            }

            <!-- Products Section - Show after phone check -->
            @if (phoneChecked) {
            <div class="products-section">
                <h3>Sélectionnez les produits</h3>
                @if (products.length === 0) {
                <p class="no-products">Aucun produit disponible pour le moment.</p>
                } @else {
                <div class="products-grid">
                    @for (product of products; track product.id) {
                    <div class="product-card"
                        (click)="toggleProductSelection(product)">
                        <div class="product-header">
                            <h4>{{ product.name }}</h4>
                            <input type="radio"  formControlName="productId" name="productId" value="{{product.id}}"  />
                        </div>
                        <div class="product-details">
                            <p><strong>Type:</strong> {{ product.type }}</p>
                            <p><strong>Zone:</strong> {{ product.zone }}</p>
                            <p><strong>Prix:</strong> {{ product.price }} CFA</p>
                            <p><strong>Durée:</strong> {{ product.durationYears }} ans</p>
                            <p><strong>Superficie:</strong> {{ product.superficie }} m²</p>
                        </div>
                    </div>
                    }
                </div>
                }

                @if (selectedProduct === null) {
                <div class="error">
                    <span>Veuillez sélectionner au moins un produit.</span>
                </div>
                }
            </div>

            <!-- Subscription Details Section - Show when products are selected -->
            @if (selectedProduct!=null ) {
            <div class="form-section">
                <h3>Détails de la souscription</h3>

                <div class="grid-row">
                    <div class="field-group">
                        <label for="paymentFrequency">Fréquence de paiement</label>
                        <select id="paymentFrequency" formControlName="paymentFrequency" (change)="calculatePeridicAmount()">
                            <option value="">Choisir une fréquence de paiement</option>
                            <option value="MENSUEL">Mensuel</option>
                            <option value="TRIMESTRIEL">Trimestriel</option>
                            <option value="SEMESTRIEL">Semestriel</option>
                            <option value="ANNUEL">Annuel</option>
                        </select>
                    </div>

                   
                    <div class="field-group">
                        <label for="periodicAmount">Montant annuité</label>
                        <input id="periodicAmount" type="number" formControlName="periodicAmount" min="0" />
                    </div>
                   
                   
                    
                </div>


            </div>
            }

            <!-- Form Actions - Show after phone check -->
            @if (phoneChecked) {
            <div class="form-actions">
                <button type="submit" class="btn btn-primary">Créer la souscription</button>
                <button type="button" class="btn btn-secondary" (click)="resetForm()">Réinitialiser</button>
            </div>
            }
            }
        </form>


    </div>
</div>